import { render, staticRenderFns } from "./tracker-organizations-by-sector.vue?vue&type=template&id=df36b346&scoped=true&"
import script from "./tracker-organizations-by-sector.vue?vue&type=script&lang=js&"
export * from "./tracker-organizations-by-sector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df36b346",
  null
  
)

export default component.exports